export const APP_AUTH_TOKEN = 'app_auth_token'
export const APP_ONBOARDING = 'app_onboarding'
export const APP_UTMS = 'app_utms'

export const AUTH_ORIGINS = {
    APP_ONLY_COUPONS: 'appOnlyCoupons',
    ONBOARDING: 'isOnboarding'
}

export const PLATFORMS = {
    CONVERTR: 'convertr',
    LOJAINTEGRADA: 'lojaintegrada',
    NUVEMSHOP: 'nuvemshop',
    TRAY: 'tray',
    BAGY: 'bagy',
    WIX: 'wix',
    WEBVIEW: 'webview',
    IRROBA: "irroba",
    OTHER: 'other'
}

export const platformsWithAbandonedCartNotificationsInWebviewTheme = [
    PLATFORMS.TRAY,
    PLATFORMS.BAGY,
    PLATFORMS.NUVEMSHOP,
    PLATFORMS.LOJAINTEGRADA
]

export const appPublishStatus = {
    FIRST_PUBLISH_PENDING: "first_publish_pending",
    PENDING_LISTING_CREATION: "pending_listing_creation",
    DEVELOPER_ACCOUNT_PENDING: "developer_account_pending",
    PUBLISHING: "publishing",
    PENDING_GOOGLE_PLAY_DEVELOPER_ACCOUNT_VERIFICATION: "pending_google_play_developer_account_verification",
    PENDING_APPLE_ACCOUNT_RENEWAL: "pending_apple_account_renewal",
    PENDING_APPLE_ACCOUNT_TERMS_AGREEMENT: "pending_apple_account_terms_agreement",
    IN_REVIEW: "in_review",
    PUBLISHED: "published",
    PENDING_UPDATE: "pending_update"
}

// Statuses that represent an external blocker (developer account pending, terms to
// agree to, expired subscription). The store user has to solve the pending issue on
// the Apple/Google account before requesting a new publication.
export const blockingAppPublishStatus = [
    appPublishStatus.DEVELOPER_ACCOUNT_PENDING,
    appPublishStatus.PENDING_GOOGLE_PLAY_DEVELOPER_ACCOUNT_VERIFICATION,
    appPublishStatus.PENDING_APPLE_ACCOUNT_RENEWAL,
    appPublishStatus.PENDING_APPLE_ACCOUNT_TERMS_AGREEMENT
]

export const onboardingSteps = {
    PROFILE: 'profile',
    CONNECT: 'connect',
    PROMISE: 'promise',
    BRAND: 'brand',
    PREVIEW: 'preview',
    PUSH: 'push',
    CONCLUDE: 'conclude'
}

// Profile is the first step of the onboarding flow.
export const onboardingStepsOrder = [
    onboardingSteps.PROFILE,
    onboardingSteps.CONNECT,
    onboardingSteps.PROMISE,
    onboardingSteps.BRAND,
    onboardingSteps.PREVIEW,
    onboardingSteps.PUSH,
    onboardingSteps.CONCLUDE
]

// Each screen renders one of these states at a time. The first one is the
// default applied whenever the step changes.
// The states of the connect screen on which the platform authorization modal is open
export const onboardingConnectModalStates = ['openModalAuthorization', 'openModalRedirecting']

export const onboardingScreenStates = {
    [onboardingSteps.PROFILE]: ['default', 'referralSelected', 'otherSelected'],
    [onboardingSteps.CONNECT]: ['default', 'expanded', 'other', ...onboardingConnectModalStates, 'connecting'],
    [onboardingSteps.PROMISE]: ['default'],
    [onboardingSteps.BRAND]: ['default', 'uploaded', 'error'],
    [onboardingSteps.PREVIEW]: ['waiting', 'delay', 'paused', 'detected'],
    [onboardingSteps.PUSH]: ['ready', 'arrived', 'composer', 'fail'],
    [onboardingSteps.CONCLUDE]: ['default']
}

export const mixpanelEvents = {
    ONBOARDING_INITIATED: 'onboarding_initiated',
    ONBOARDING_ECOMMERCE_PLATFORM_SELECTED: 'onboarding_ecommerce_platform_selected',
    ONBOARDING_PLATFORM_AUTH_INITIATED: 'onboarding_platform_auth_initiated',
    ONBOARDING_CUSTOMIZATION_CONCLUDED: 'onboarding_customization_concluded',
    ONBOARDING_PREVIEWER_LINK_CLICKED: 'onboarding_previewer_link_clicked',
    ONBOARDING_PREVIEWER_QR_SCAN_DELAYED: 'onboarding_previewer_qr_scan_delayed',
    ONBOARDING_GO_TO_NOTIFICATION_CLICKED: 'onboarding_go_to_notification_clicked',
    ONBOARDING_CONCLUSION_GO_TO_PLANS_CLICKED: 'onboarding_conclusion_go_to_plans_clicked',
    ONBOARDING_CONCLUSION_GO_TO_PANEL_CLICKED: 'onboarding_conclusion_go_to_panel_clicked',
    ONBOARDING_PREVIEWER_DETECTED: 'onboarding_previewer_detected',
    ONBOARDING_PREVIEWER_DOWNLOAD_SCREEN_SHOWN: 'onboarding_previewer_download_screen_shown',
    ONBOARDING_PLATFORM_AUTH_SUCCESS: 'onboarding_platform_auth_success',
    ONBOARDING_PLATFORM_AUTH_FAILED: 'onboarding_platform_auth_failed',
    ONBOARDING_PREVIEWER_DOWNLOAD_SKIPPED: 'onboarding_previewer_download_skipped',
    ONBOARDING_PUSH_SKIPPED: 'onboarding_push_skipped',
    ONBOARDING_STORE_URL_INSERTED: 'onboarding_store_url_inserted'
}

export const platformAuthFailureReasons = {
    CANCELED: 'cancelled_by_the_user'
}

export const mobileAppPlatforms = {
    ANDROID: 'android',
    IOS: 'ios'
}

export const storeStatus = {
    ON_TRIAL: "on_trial",
    TRIAL_ENDED: "trial_ended",
    ACTIVE: "active",
    SUSPENDED: "suspended",
    ARCHIVED: "archived"
}

export const subscriptionStatus = {
    UNDEFINED: "undefined",
    PENDING: "pending",
    ACTIVE: "active",
    EXPIRED: "expired",
    PENDING_SUSPENSION: "pending_suspension",
    SUSPENDED: "suspended"
}

export const platformsOnboardingIntegration = [
    'nuvemshop',
    'wix',
    'irroba',
    'tray',
    'bagy'
]

export const platformsThatProvideStoreUrl = [
    PLATFORMS.NUVEMSHOP,
    PLATFORMS.WIX
]

export const planIds = {
    PLAN_INITIAL: 'plan_initial',
    PLAN_BASIC_MONTHLY_2023: 'plano_basico_mensal_2023',
    PLAN_BASIC_YEARLY_2023: 'plano_basico_anual_2023',
    PLAN_PRO_MONTHLY_2023: 'plano_pro_mensal_2023',
    PLAN_PRO_YEARLY_2023: 'plano_pro_anual_2023',
    PLAN_BASIC_MONTHLY_2024: 'plano_basico_mensal_2024',
    PLAN_BASIC_YEARLY_2024: 'plano_basico_anual_2024',
    PLAN_PRO_MONTHLY_2024: 'plano_pro_mensal_2024',
    PLAN_PRO_YEARLY_2024: 'plano_pro_anual_2024',
    PLAN_EXCLUSIVE_MONTHLY_2023: 'plano_exclusivo_mensal_2023',
    PLAN_PRO_SMART_PUSH_2023: 'plano_pro_smart_push_2023',
    PLAN_PRO_SMART_PUSH_TRAY_2023: 'plano_pro_smart_push_tray_2023',
    PLAN_PRO_SMART_PUSH_VALUE_100: 'plano_pro_smart_push_valor_100',
    PLAN_EXCLUSIVE_MONTHLY_VALUE_200: 'plano_exclusivo_mensal_valor_200',
    PLAN_EXCLUSIVE_MONTHLY_VALUE_300: 'plano_exclusivo_mensal_valor_300',
    PLAN_EXCLUSIVE_MONTHLY_VALUE_399: 'plano_exclusivo_mensal_valor_399',
    PLAN_EXCLUSIVE_MONTHLY_VALUE_400: 'plano_exclusivo_mensal_valor_400',
    PLAN_EXCLUSIVE_299_MONTHLY_2024: 'plano_exclusivo_299_mensal_2024',
    PLAN_BASIC_ACCOUNT_GOOGLE_MONTHLY_2025: 'plano_basico_conta_google_mensal_2025',
    PLAN_PRO_ACCOUNT_GOOGLE_MONTHLY_2025: 'plano_pro_conta_google_mensal_2025'
}

export const planPeriodicity = {
    MONTHLY: "monthly",
    YEARLY: "yearly"
}

export const availablePlans = {
    basic: {
        monthly: "plano_basico_mensal_2024",
        yearly: "plano_basico_anual_2024",
    },
    pro: {
        monthly: "plano_pro_mensal_2024",
        yearly: "plano_pro_anual_2024",
    },
}

export const plans = {
    plan_initial: {
        name: "Pro",
        isBasic: false,
        price: 99,
        totalPrice: 99,
        periodicity: planPeriodicity.MONTHLY,
    },
    plan_initial_annual: {
        name: "Pro",
        isBasic: false,
        price: 99,
        totalPrice: 1069,
        periodicity: planPeriodicity.YEARLY,
    },
    plan_monthly_2022: {
        name: "Pro",
        isBasic: false,
        price: 99,
        totalPrice: 99,
        periodicity: planPeriodicity.MONTHLY,
    },
    plan_annual_2022: {
        name: "Pro",
        isBasic: false,
        price: 99,
        totalPrice: 1068,
        periodicity: planPeriodicity.YEARLY,
    },
    plan_monthly_2023: {
        name: "Pro",
        isBasic: false,
        price: 149,
        totalPrice: 149,
        periodicity: planPeriodicity.MONTHLY,
    },
    plan_annual_2023: {
        name: "Pro",
        isBasic: false,
        price: 149,
        totalPrice: 1548,
        periodicity: planPeriodicity.YEARLY
    },
    plano_basico_mensal_2023: {
        name: "Básico",
        isBasic: true,
        price: 99,
        totalPrice: 99,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_basico_anual_2023: {
        name: "Básico",
        isBasic: true,
        price: 89,
        totalPrice: 1068,
        periodicity: planPeriodicity.YEARLY
    },
    plano_pro_mensal_2023: {
        name: "Pro",
        isBasic: false,
        price: 149,
        totalPrice: 149,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_pro_anual_2023: {
        name: "Pro",
        isBasic: false,
        price: 129,
        totalPrice: 1548,
        periodicity: planPeriodicity.YEARLY
    },
    plano_basico_mensal_2024: {
        name: "Básico",
        isBasic: true,
        price: 129,
        totalPrice: 129,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_basico_anual_2024: {
        name: "Básico",
        isBasic: true,
        price: 109,
        totalPrice: 1308,
        periodicity: planPeriodicity.YEARLY
    },
    plano_pro_mensal_2024: {
        name: "Pro",
        isBasic: false,
        price: 199,
        totalPrice: 199,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_pro_anual_2024: {
        name: "Pro",
        isBasic: false,
        price: 169,
        totalPrice: 2028,
        periodicity: planPeriodicity.YEARLY
    },
    plano_exclusivo_mensal_2023: {
        name: "Exclusivo",
        isBasic: false,
        price: 599,
        totalPrice: 599,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_pro_smart_push_2023: {
        name: "Pro + Push Inteligente",
        isBasic: false,
        price: 299,
        totalPrice: 299,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_pro_smart_push_tray_2023: {
        name: "Pro + Push Inteligente",
        isBasic: false,
        price: 200,
        totalPrice: 200,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_pro_smart_push_valor_100: {
        name: "Pro + Push Inteligente",
        isBasic: false,
        price: 100,
        totalPrice: 100,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_exclusivo_mensal_valor_200: {
        name: "Exclusivo",
        isBasic: false,
        price: 200,
        totalPrice: 200,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_exclusivo_mensal_valor_300: {
        name: "Exclusivo",
        isBasic: false,
        price: 300,
        totalPrice: 300,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_exclusivo_mensal_valor_399: {
        name: "Exclusivo",
        isBasic: false,
        price: 399,
        totalPrice: 399,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_exclusivo_mensal_valor_400: {
        name: "Exclusivo",
        isBasic: false,
        price: 400,
        totalPrice: 400,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_exclusivo_299_mensal_2024: {
        name: "Exclusivo",
        isBasic: false,
        price: 299,
        totalPrice: 299,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_basico_conta_google_mensal_2025: {
        name: "Básico",
        isBasic: true,
        price: 149,
        totalPrice: 149,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_pro_conta_google_mensal_2025: {
        name: "Pro",
        isBasic: false,
        price: 229,
        totalPrice: 229,
        periodicity: planPeriodicity.MONTHLY
    },
    plano_adicional_conta_google_2025: {
        name: "Adicional - Publicação Google",
        isBasic: false,
        price: 20,
        totalPrice: 20,
        periodicity: planPeriodicity.MONTHLY
    }
}

export const baseDeeplink = "https://mobilizei.onelink.me/omcI?af_xp=qr&pid=QR_code&af_dp=mobilizei%3A%2F%2F&af_force_deeplink=true"